import { Title } from '@app/components/core/typography/Title'
import Column from '@app/components/layout/Column'
import { Text } from '@app/components/core/typography/Text'
import { ReactNode } from 'react'

export type EditItemProps = {
  editMode: boolean
  label: string
  displayValue: string | number
  children: ReactNode
}

export const EditItem = (props: EditItemProps) => {
  if (!props.editMode) {
    return (
      <Column gap={'0.5rem'}>
        <Title.H5>{props.label}</Title.H5>
        <Text.Medium color="var(--shades-blue-500)">
          {props.displayValue}
        </Text.Medium>
      </Column>
    )
  }

  return props.children
}
